export function quadIn(t) {
  return t * t;
}
export function quadOut(t) {
  return t * (2 - t);
}
export function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-ease@1.0.7@d3-ease/src/quad.js
// module id = 144
// module chunks = 0